import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Section = ({ title, children }) => (
  <div className="mb-12" data-testid="legal-section">
    <h2 className="font-inter text-label-sm uppercase tracking-widest text-brand-secondary mb-4">
      {title}
    </h2>
    <div className="font-cormorant text-body-md text-deep-taupe space-y-4 leading-relaxed">
      {children}
    </div>
  </div>
);

const Legal = () => {
  return (
    <div id="top" className="min-h-screen flex flex-col bg-background-ivory">
      <Header />
      <main className="flex-1 pt-36 md:pt-44 pb-24">
        <div className="max-w-2xl mx-auto px-6">
          <p className="font-inter text-eyebrow uppercase tracking-widest text-brand-secondary mb-4">
            The Kitchen Art Co.
          </p>
          <h1
            className="font-cormorant text-4xl sm:text-5xl text-brand-ink mb-10"
            data-testid="legal-title"
          >
            Legal &amp; Privacy
          </h1>

          <Section title="Ownership">
            <p>
              This website and all of its contents — text, photography, menus and
              marks — are the property of The Kitchen Art Co. and are protected
              under applicable copyright and trademark law. Nothing here may be
              reproduced without our written permission.
            </p>
          </Section>

          <Section title="Privacy">
            <p>
              When you write to us through our enquiry form, we collect only the
              details you choose to share — your name, contact information and a
              note about your occasion. We use these solely to respond to your
              enquiry and to plan your event. We never sell or share your details
              with third parties for marketing.
            </p>
          </Section>

          <Section title="Enquiries &amp; Data">
            <p>
              You may ask us at any time to view, correct or delete the
              information you have shared. Simply write to us and we will attend to
              it promptly.
            </p>
          </Section>

          <Section title="Contact">
            <p>
              For any question about this notice, or about how we look after your
              information, please reach us at{" "}
              <a
                href="mailto:tkac@tkac.in"
                className="text-brand-ink underline underline-offset-4 hover:text-bright-gold-on-dark transition-colors"
                data-testid="legal-email-link"
              >
                tkac@tkac.in
              </a>
              .
            </p>
          </Section>

          <p className="font-inter text-label-sm text-brand-secondary/70 mt-16">
            © {new Date().getFullYear()} The Kitchen Art Co. All rights reserved.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Legal;
